// extracted by mini-css-extract-plugin
export default {"galleryItem":"c-o_fp","galleryItem_borderTopRadius":"c-o_fq","galleryItem__image":"c-o_fr"};